import GarminConnectCompleteActivityTriggerIntegrationInstructionsComponent from '@cohort/components-xps/components/apps/garmin-conect/triggers/completeActivity/InstructionsComponent';
import type {GarminConnectCompleteActivityTriggerStruct} from '@cohort/shared/apps/garmin-connect/triggers/completeActivity';
import {GarminConnectCompleteActivityTriggerIntegrationSpec} from '@cohort/shared/apps/garmin-connect/triggers/completeActivity';
import GarminConnectCompleteActivityTriggerIntegrationDetailComponent from '@cohort/wallet/apps/garmin-connect/triggerIntegrations/completeActivity/DetailComponent';
import type {TriggerIntegration} from '@cohort/wallet/apps/TriggerIntegration';

export const GarminConnectCompleteActivityTriggerIntegration: TriggerIntegration<GarminConnectCompleteActivityTriggerStruct> =
  {
    type: 'verification',
    spec: GarminConnectCompleteActivityTriggerIntegrationSpec,
    detailsComponent: GarminConnectCompleteActivityTriggerIntegrationDetailComponent,
    instructionsComponent: GarminConnectCompleteActivityTriggerIntegrationInstructionsComponent,
    disableExponentialBackoff: true,
  };
